<div class="donors">
  <img loading="lazy" class="donors-img" [attr.data-src]="supporterImg" />
  <span class="donor-count"><strong> {{paymentv2?.sipDonors?.monthlyDonors | inrFormat:'INR'}}</strong> {{label}}</span>
</div>
